import { render, staticRenderFns } from "./FareMatrixData.vue?vue&type=template&id=e87328b8&scoped=true&slot=headers&slot-scope=props&"
import script from "./FareMatrixData.vue?vue&type=script&lang=js&"
export * from "./FareMatrixData.vue?vue&type=script&lang=js&"
import style0 from "./FareMatrixData.vue?vue&type=style&index=0&id=e87328b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e87328b8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VContainer,VDataTable,VFlex,VIcon,VLayout,VSelect,VTooltip})
